import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import {
  Paper,
  makeStyles,
  ListSubheader,
} from '@material-ui/core'


const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(1),
    marginTop: theme.spacing(1),
  },
  title: {
    background: 'transparent',
  },
  rootWithTitle: {
    paddingTop: 0,
    paddingLeft: 0,
  },
  content: {
    padding: theme.spacing(1),
  },
  contentWithTitle: {
    paddingLeft: theme.spacing(2),
  },
}))


const Panel = ({
  title,
  children,
  className,
}) => {
  const classes = useStyles()

  return (
    <Paper
      className={classNames(classes.root, {
        [classes.rootWithTitle]: !!title,
      }, className)}
    >
      {title && <ListSubheader>{title}</ListSubheader>}

      <div
        className={classNames(classes.content, {
          [classes.contentWithTitle]: !!title,
        })}
      >
        {children}
      </div>
    </Paper>
  )
}


Panel.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
}


export default Panel
